export default __webpack_public_path__ + "5137c23aef8dd649d350fd4ff663a025.png";